<template>
    <div class="shop-page">
        <div>
            <Toast />
            <div class="product-group">
                <div class="product-group-header">
                    <img class="background" src="assets/layout/images/network-bg.png" alt="">
                    <h2>Basic</h2>
                    <!-- <img class="product-icon" src="assets/layout/images/packages/product-basic.png" alt=""> -->
                </div>
                <div class="package-cards">
                    <div v-for="item in basicPackages(packages)" :key="item.id" class="card card-package">
                        <div class="card-package-header">
                            <div class="info">
                                <h3>{{ item.name }}</h3>
                            </div>
                            <div class="info-actions">
                                <div class="package-select">
                                    <Button label="Select" @click="goto_payments(item)"></Button>
                                </div>
                            </div>
                            <div class="info-price">
                                <span class="price">{{ formatCurrency(item.price) }} ETH</span>
                            </div>
                        </div>
                        <div class="card-package-body">
                            <div class="description-item" v-for="desc in formatDescription(item.description)" :key="desc">
                                <span class="check-icon pi pi-check"></span>
                                <span class="text">{{ desc }}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="product-group">
                <div class="product-group-header">
                    <img class="background" src="assets/layout/images/network-bg.png" alt="">
                    <h2>Standard</h2>
                    <!-- <img class="product-icon" src="assets/layout/images/packages/product-basic.png" alt=""> -->
                </div>
                <div class="package-cards">
                    <div v-for="item in standardPackages(packages)" :key="item.id" class="card card-package">
                        <div class="card-package-header">
                            <div class="info">
                                <h3>{{ item.name }}</h3>
                            </div>
                            <div class="info-actions">
                                <div class="package-select">
                                    <Button label="Select" @click="goto_payments(item)"></Button>
                                </div>
                            </div>
                            <div class="info-price">
                                <span class="price">{{ formatCurrency(item.price) }} ETH</span>
                            </div>
                        </div>
                        <div class="card-package-body">
                            <div class="description-item" v-for="desc in formatDescription(item.description)" :key="desc">
                                <span class="check-icon pi pi-check"></span>
                                <span class="text">{{ desc }}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="product-group">
                <div class="product-group-header">
                    <img class="background" src="assets/layout/images/network-bg.png" alt="">
                    <h2>Professional</h2>
                    <!-- <img class="product-icon" src="assets/layout/images/packages/product-basic.png" alt=""> -->
                </div>
                <div class="package-cards">
                    <div v-for="item in professionalPackages(packages)" :key="item.id" class="card card-package">
                        <div class="card-package-header">
                            <div class="info">
                                <h3>{{ item.name }}</h3>
                            </div>
                            <div class="info-actions">
                                <div class="package-select">
                                    <Button label="Select" @click="goto_payments(item)"></Button>
                                </div>
                            </div>
                            <div class="info-price">
                                <span class="price">{{ formatCurrency(item.price) }} ETH</span>
                            </div>
                        </div>
                        <div class="card-package-body">
                            <div class="description-item" v-for="desc in formatDescription(item.description)" :key="desc">
                                <span class="check-icon pi pi-check"></span>
                                <span class="text">{{ desc }}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

             <div class="product-group">
                <div class="product-group-header">
                    <img class="background" src="assets/layout/images/network-bg.png" alt="">
                    <h2>Ultimate</h2>
                    <!-- <img class="product-icon" src="assets/layout/images/packages/product-basic.png" alt=""> -->
                </div>
                <div class="package-cards">
                    <div v-for="item in ultimatePackages(packages)" :key="item.id" class="card card-package">
                        <div class="card-package-header">
                            <div class="info">
                                <h3><h3>{{ item.name }}</h3></h3>
                            </div>
                            <div class="info-actions">
                                <div class="package-select">
                                    <Button label="Select" @click="goto_payments(item)"></Button>
                                </div>
                            </div>
                            <div class="info-price">
                                <span class="price">{{ formatCurrency(item.price) }} ETH</span>
                            </div>
                        </div>
                        <div class="card-package-body">
                            <div class="description-item" v-for="desc in formatDescription(item.description)" :key="desc">
                                <span class="check-icon pi pi-check"></span>
                                <span class="text">{{ desc }}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

         
        </div>
    </div>
</template>

<script>


    import PackageService from '../../service/PackageService';


    export default {
        data() {
            return {
                packages: null,
                selected_package: null,
                editingCellRows: {},
                editingRows: [],
                columns: null,
                responsiveOptions: [
                    {
                        breakpoint: '1024px',
                        numVisible: 3,
                        numScroll: 3
                    },
                    {
                        breakpoint: '600px',
                        numVisible: 2,
                        numScroll: 2
                    },
                    {
                        breakpoint: '480px',
                        numVisible: 1,
                        numScroll: 1
                    }
                ]

            }
        },
        created() {
            this.$store.commit('setPageTitle', { pageTitle: 'PACKAGES' });
            this.packageService = new PackageService();
            this.columns = [
                { field: 'name', header: 'Name' },
                { field: 'price', header: 'Price' }

            ];

            this.originalRows = {};
        },
        async mounted() {
            this.packageService.getPackages(this.$store.state.currentUser.token).then(data => this.packages = data);

         
        },
        methods: {
            formatCurrency(value) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                // return new Intl.NumberFormat('de-DE', { style: 'integer' }).format(value);
            },

            formatDescription(desc) {
                let points = desc.split(', ');
                if (points.length > 0)
                    return points;
                else return null;
            },
            basicPackages(packages) {
                if (packages) {
                    return packages.filter(el => el.name.includes('Basic'));
                }
            },
            standardPackages(packages) {
                if (packages) {
                    return packages.filter(el => el.name.includes('Standard'));
                }
            },
            professionalPackages(packages) {
                if (packages) {
                    return packages.filter(el => el.name.includes('Pro'));
                }
            },
            ultimatePackages(packages) {
                if (packages) {
                    return packages.filter(el => el.name.includes('Ult'));
                }
            },
        
            goto_payments(data) {

                //console.log(data.id);

                this.$store.commit('updateSelectedPackage', data)
                this.$router.push({ name: 'payment', params: { data: data } });
            },
            goto_document(url) {
                window.open(url, '_blank')
                // this.$router.push('/admin/documents/products')
            },
        }
    }



</script>

<style scoped>

    .package-title {
        font-weight: 600;
        font-size: 22px;
        margin-top: 24px;
    }



    .package-content {
        border: 1px solid var(--layer-2);
        border-radius: 3px;
        margin: .3rem;
        text-align: center;
        padding: 2em 0 2.25em 0;
    }


    .package-subtitle {
        margin: .25em 0 2em 0;
        font-size: 22px;
    }

    .package-select {
        margin-left: .5rem;
        font-size: 22px;
    }

    .package-description {
        margin-left: .5rem;
        margin-top: 24px;
        margin-bottom: 24px;
        font-size: 16px;
        text-align: left;
    }
</style>